<script setup lang="ts">
import type { RetailBlockType } from '~/interfaces/api';

const { $retailRocketRender } = useNuxtApp();
const reload = ref(true);
const props = defineProps({
  retailBlock: {
    type: Object as () => RetailBlockType | undefined,
    default: undefined,
  },
});
onMounted(() => {
  if ($retailRocketRender && props.retailBlock) $retailRocketRender(true);
});
</script>

<template>
  <div
    v-if="retailBlock && reload"
    class="retail-block-list"
    :data-retailrocket-markup-block="retailBlock.markup"
    :data-category-id="retailBlock.category_id"
    :data-stock-id="retailBlock.region"
    :data-search-phrase="retailBlock.dataSearchPhrase"
  />
</template>

<style scoped lang="scss">
.retail-block-list {
  width: 100%;
}
</style>
